module.exports = __webpack_public_path__ + "img/rmc-logo-icon-BLU-WHT.59975bba.png";